import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

// Async thunk to create budget
export const createEngagementBudget = createAsyncThunk(
  "engagementMetrics/createBudget",
  async (budgetData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/budgets/bulk",
        //  "https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/budgets/bulk",
        budgetData,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to create transactions
export const createEngagementTransactions = createAsyncThunk(
  "engagementMetrics/createTransactions",
  async (transactionsData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction",
        transactionsData,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getMonthlyTransactionData = createAsyncThunk(
  "engagementMetrics/getMonthlyTransactionData",
  async ({ supplierId, buyerId, isTotal = false }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        // `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/monthly/current?isTotal=${isTotal}&supplierId=${supplierId}&buyerId=${buyerId}`,
       `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/monthly/current?isTotal=${isTotal}&supplierId=${supplierId}&buyerId=${buyerId}`,
        {
          headers: {
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
            accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getLastThreeMonthsTransactionData = createAsyncThunk(
  "engagementMetrics/getLastThreeMonthsTransactionData",
  async ({ supplierId, buyerId, isTotal = false }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        // `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/monthly/last-three?isTotal=${isTotal}&supplierId=${supplierId}&buyerId=${buyerId}`,
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/monthly/last-three?isTotal=${isTotal}&supplierId=${supplierId}&buyerId=${buyerId}`,
        {
          headers: {
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
            accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getYearlyTransactionData = createAsyncThunk(
  "engagementMetrics/getYearlyTransactionData",
  async ({ supplierId, buyerId, isTotal = false }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        // `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/yearly-budget?isTotal=${isTotal}&supplierId=${supplierId}&buyerId=${buyerId}`,
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/yearly-budget?isTotal=${isTotal}&supplierId=${supplierId}&buyerId=${buyerId}`,
        {
          headers: {
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
            accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const getMonthlyTransactions = createAsyncThunk(
  "transactions/getMonthly",
  async ({ supplierId, buyerId, searchString }) => {
    const response = await axios.get(
      `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/monthly/current?isTotal=false&supplierId=${supplierId}&buyerId=${buyerId}&searchString=${searchString}`,
      {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
    );
    return response.data;
  }
);

export const getYearlyTransactions = createAsyncThunk(
  "transactions/getYearly",
  async ({ supplierId, buyerId, searchString }) => {
    const response = await axios.get(
      `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/yearly-budget?isTotal=false&supplierId=${supplierId}&buyerId=${buyerId}&searchString=${searchString}`,
      {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
    );
    return response.data;
  }
);

export const getLast3MonthsTransactions = createAsyncThunk(
  "transactions/getLast3Months",
  async ({ supplierId, buyerId, searchString }) => {
    const response = await axios.get(
      `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/monthly/last-three?isTotal=false&supplierId=${supplierId}&buyerId=${buyerId}&searchString=${searchString}`,
      {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
    );
    return response.data;
  }
);

export const getAllTransactions = createAsyncThunk(
  "transactions/getAllTransactions",
  async ({ supplierId, buyerId, searchString }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        // `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/all`,
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/all`,
        {
          params: {
            supplierId,
            buyerId,
            searchString
          },
          headers: {
            accept: "application/json",
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch transactions"
      );
    }
  }
);
export const getAllSearchTransactions = createAsyncThunk(
  "transactions/getAllSearchTransactions",
  async ({ supplierId, buyerId, searchString }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        // `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/all`,
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/all`,
        {
          params: {
            supplierId,
            buyerId,
            searchString
          },
          headers: {
            accept: "application/json",
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch transactions"
      );
    }
  }
);

export const updateTransaction = createAsyncThunk(
  "transactions/updateTransaction",
  async ({ transactionId, supplierId, buyerId, data }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction/${transactionId}?supplierId=${supplierId}&buyerId=${buyerId}`,
        data,
        {
          headers: {
            accept: "application/json",
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const deleteTransactions = createAsyncThunk(
  "transactions/deleteTransactions",
  async ({ supplierId, buyerId, transactionIds }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/transaction?supplierId=${supplierId}&buyerId=${buyerId}`,
        {
          headers: {
            accept: "application/json",
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
          },
          data: {
            transactionIds,
          },
        }
      );

      return { transactionIds };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateBudget = createAsyncThunk(
  "transactions/updateBudget",
  async ({ budgetId, supplierId, buyerId, data }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/management/engagement/budgets/${budgetId}?supplierId=${supplierId}&buyerId=${buyerId}`,
        data,
        {
          headers: {
            accept: "application/json",
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const deleteBudget = createAsyncThunk(
  "transactions/deleteBudget",
  async ({ supplierId, buyerId, budgetIds }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net//api/management/engagement/budgets/bulk?supplierId=${supplierId}&buyerId=${buyerId}`,
        {
          headers: {
            accept: "application/json",
            "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
          },
          data: {
            budgetIds,
          },
        }
      );

      return { budgetIds };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const engagementMetricsSlice = createSlice({
  name: "engagementMetrics",
  initialState: {
    budget: [],
    spend: [],
    transactions: [],
    monthlyTransactions: [],
    lastThreeMonthsTransactions: [],
    yearlyTransactions: [],
    selectedPeriod: "",
    totalBudget: 0,
    totalSpend: 0,
    loading: false,
    error: null,
  },
  reducers: {
    setBudget(state, action) {
      state.budget = action.payload;
    },
    setSpend(state, action) {
      state.spend = action.payload;
    },
    setTransactions(state, action) {
      state.transactions = action.payload;
    },
    clearEngagementState(state) {
      state.budget = [];
      state.spend = [];
      state.transactions = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEngagementBudget.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createEngagementBudget.fulfilled, (state, action) => {
        state.loading = false;
        state.budget = action.payload;
      })
      .addCase(createEngagementBudget.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(createEngagementTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createEngagementTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload;
      })
      .addCase(createEngagementTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getMonthlyTransactionData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMonthlyTransactionData.fulfilled, (state, action) => {
        const summary = action.payload.currentMonthSummary;

        state.loading = false;
        state.monthlyTransactions = action.payload.monthlyBudget;
        state.totalBudget = summary.totalBudget;
        state.totalSpend = summary.totalAmount;
        state.selectedPeriod =
          summary.startMonth === summary.endMonth
            ? `${summary.startMonth} ${summary.currentYear}`
            : `${summary.startMonth} - ${summary.endMonth} ${summary.currentYear}`;
      })
      .addCase(getMonthlyTransactionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getLastThreeMonthsTransactionData.fulfilled, (state, action) => {
        const summary = action.payload.lastThreeMonthSummary;

        state.loading = false;
        state.lastThreeMonthsTransactions =
          action.payload.lastThreeMonthsBudget;
        state.totalBudget = summary.totalBudget;
        state.totalSpend = summary.totalAmount;
        state.selectedPeriod =
          summary.startMonth === summary.endMonth
            ? `${summary.startMonth} ${summary.currentYear}`
            : `${summary.startMonth} - ${summary.endMonth} ${summary.currentYear}`;
      })

      .addCase(getYearlyTransactionData.fulfilled, (state, action) => {
        const summary = action.payload.currentYearSummary;

        state.loading = false;
        state.yearlyTransactions = action.payload.yearlyBudget;
        state.totalBudget = summary.totalBudget;
        state.totalSpend = summary.totalAmount;
        state.selectedPeriod =
          summary.startMonth === summary.endMonth
            ? `${summary.startMonth} ${summary.currentYear}`
            : `${summary.startMonth} - ${summary.endMonth} ${summary.currentYear}`;
      })
        .addCase(getMonthlyTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyTransactions = action.payload.monthlyBudget;
      })
        .addCase(getYearlyTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.yearlyTransactions = action.payload.yearlySummary;
      })
      .addCase(getLast3MonthsTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.lastThreeMonthsTransactions = action.payload.lastThreeMonthSummary;
      })
      .addCase(getAllTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload;
      })
  
      .addCase(getAllSearchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload;
      })
      .addCase(updateTransaction.fulfilled, (state, action) => {
        const { transactionId } = action.payload;
        const index = state.transactions.findIndex(
          (item) => item.transactionId === transactionId
        );
        if (index !== -1) {
          state.transactions[index] = {
            ...state.transactions[index],
            ...action.payload,
          };
        }
      })
      .addCase(updateBudget.fulfilled, (state, action) => {
        const { budgetId } = action.payload;
        const index = state.budget.findIndex(
          (item) => item.budgetId === budgetId
        );
        if (index !== -1) {
          state.budget[index] = {
            ...state.budget[index],
            ...action.payload,
          };
        }
      })

      .addCase(deleteTransactions.fulfilled, (state, action) => {
        const { transactionIds } = action.payload;
        state.transactions = state.transactions.filter(
          (transaction) => !transactionIds.includes(transaction.transactionId)
        );
      })
      .addCase(deleteBudget.fulfilled, (state, action) => {
        const { budgetIds } = action.payload;
        state.budget = state.budget.filter(
          (budget) => !budgetIds.includes(budget.budgetId)
        );
      });
  },
});

export const { setBudget, setSpend, setTransactions, clearEngagementState } =
  engagementMetricsSlice.actions;

export default engagementMetricsSlice.reducer;
